import { Holder3D } from "../../../types/holder3d";
import { IPartsChildren } from "../../../types/IPartsConfigSchema";
import { Mesh } from "three";

export function applyMorphInfluences(
  conf: IPartsChildren,
  holder3D: Holder3D,
  cells: number,
) {
  if (!conf.morphInfluences) {
    return;
  }

  conf.morphInfluences
    .filter((part) => cells >= part.min && cells <= part.max)
    .forEach((part) => {
      const parentObject3D = holder3D.getObjectByName(part.parent);

      if (parentObject3D) {
        const partObject3D = parentObject3D.getObjectByName(part.part) as Mesh;

        if (partObject3D && partObject3D.morphTargetInfluences) {
          partObject3D.updateMorphTargets();

          const min = part.minCalc !== undefined ? part.minCalc : part.min,
            max = part.maxCalc !== undefined ? part.maxCalc : part.max;

          if (part.forceWeight !== undefined) {
            partObject3D.morphTargetInfluences[0] = part.forceWeight;
          } else {
            partObject3D.morphTargetInfluences[0] = (cells - min) / (max - min);
          }
        }
      }
    });
}
